import {
  LIST_REMINDER_INIT,
  LIST_REMINDER_SUCCESS,
  LIST_REMINDER_ERROR,
} from '../../actions/reminder/constants';

const initState = {
  loading: false,
  data: [],
  error: null,
};

export default (state = initState, action) => {
  switch (action.type) {
    case LIST_REMINDER_INIT:
      return { ...state, loading: true };
    case LIST_REMINDER_SUCCESS:
      return { ...state, loading: false, error: null, data: action.payload };
    case LIST_REMINDER_ERROR:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
